import React from "react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { Power, PowerOff } from "lucide-react";
import { USERS } from "@/constants/testIds";
import { initials } from "@/lib/initials";

export function UserIdentityCell({ user, isDisabled }) {
  return (
    <div className="flex items-center gap-3">
      <Avatar className="h-8 w-8">
        <AvatarFallback className={`text-xs ${isDisabled ? "bg-slate-100 text-slate-500" : "bg-orange-100 text-orange-700"}`}>
          {initials(user.display_name)}
        </AvatarFallback>
      </Avatar>
      <div>
        <div className="text-sm font-medium text-slate-900 flex items-center gap-2">
          {user.display_name}
          {isDisabled && (
            <Badge className="bg-slate-200 text-slate-600 hover:bg-slate-200 border-slate-300 text-[10px]">Inactivo</Badge>
          )}
        </div>
        <div className="text-xs text-slate-500">{user.mail}</div>
      </div>
    </div>
  );
}

export function AssignedTemplateBadge({ assigned, templateName }) {
  return assigned ? (
    <Badge className="bg-orange-100 text-orange-700 hover:bg-orange-100 border-orange-200">
      {templateName || "Plantilla"}
    </Badge>
  ) : (
    <span className="text-xs text-slate-400">Sin asignar</span>
  );
}

export function UserRowActions({ user, isDisabled, toggling, onAssign, onToggleStatus }) {
  const StatusIcon = isDisabled ? Power : PowerOff;
  return (
    <div className="flex justify-end gap-2">
      <Button size="sm" variant="outline" onClick={onAssign} disabled={isDisabled}
        data-testid={USERS.assignBtn(user.id)}
        className="border-slate-200 hover:bg-orange-50 hover:text-orange-700 hover:border-orange-200">
        Asignar firma
      </Button>
      <Button size="sm" variant="outline" onClick={onToggleStatus} disabled={toggling}
        data-testid={`toggle-status-${user.id}`}
        title={isDisabled ? "Activar usuario" : "Desactivar (excluir de publicaciones)"}
        className={isDisabled
          ? "border-emerald-200 text-emerald-700 hover:bg-emerald-50"
          : "border-slate-200 hover:bg-red-50 hover:text-red-700 hover:border-red-200"}>
        <StatusIcon className="w-3.5 h-3.5" strokeWidth={1.75} />
      </Button>
    </div>
  );
}
